import FAQ from "./FAQ";
import GettingStarted from "./GettingStarted";
import Contact from "./Contact";
import Testimonials from "./Testimonials";
import About from "./About";
import Footer from "./Footer";
import discord from "../discord_icon.svg";
import homePage from "../playguru_home.png";
import lessonPage from "../playguru_lesson.png";
import lessonCompletedPage from "../playguru_lesson_completed.png";
import modulePage from "../playguru_module.png";
import logo from "../logo_orange_rounded.png";
import AnchorLink from "react-anchor-link-smooth-scroll";

interface StylingProps {
  classes: string;
}

function Title({ classes }: StylingProps) {
  const style = `text-6xl text-center md:text-8xl font-bold ${classes}`;
  return (
    <h1 className={style}>
      {/*<h1 style={{ fontFamily: "Inter" }} className={style}>*/}
      PlayGuru
    </h1>
  );
}

function Subtitle({ classes }: StylingProps) {
  const styles = `text-2xl md:text-4xl text-center text-zinc-500 ${classes}`;
  return <h2 className={styles}>Your music companion.</h2>;
}

interface ImageProps {
  name: string;
}

function Image({ name }: ImageProps) {
  return (
    <img
      alt="name"
      src={name}
      className={
        "w-[150px] md:w-[300px] translate-y-[50px] md:translate-y-[100px] -my-[50px] md:-my-[100px]"
      }
    />
  );
}

function BottomScreenshots() {
  return (
    <div className="w-full flex flex-row overflow-hidden content-center items-center justify-start ">
      <div className="flex flex-row w-[150%] justify-center ">
        {/*<div className="flex w-fit">*/}
        <Image name={homePage} />
        <Image name={modulePage} />
        <Image name={lessonPage} />
        <Image name={lessonCompletedPage} />
        {/*</div>*/}
      </div>
    </div>
  );
}

function Welcome() {
  return (
    <div
      // style={{ backgroundImage: `url(${back})` }}
      className="bg-primary text-on_primary "
    >
      <div
        id="welcome"
        className="bp-5 p-10 py-20 flex flex-col justify-evenly items-center content-center backdrop-blur-sm"
      >
        <div className="flex flex-col justify-center content-center">
          <div className="self-center ">
            <Title classes="pb-10" />
            <Subtitle classes="pb-5" />
            <div className={"flex flex-row mt-5 justify-center"}>
              <AnchorLink
                href={"#download"}
                offset={70}
                className={
                  "mr-5 bg-secondary text-primary md:text-2xl rounded-full py-5 px-8 md:px-10 hover:bg-on_primary border-2"
                }
              >
                Get now
              </AnchorLink>
              <AnchorLink
                href="#about"
                offset={70}
                className={
                  "bg-primary text-on_primary border-on_primary border-2 md:text-2xl rounded-full py-5 px-8 md:px-10 hover:bg-on_primary hover:text-primary"
                }
              >
                More info
              </AnchorLink>
            </div>
          </div>
        </div>
      </div>
      <BottomScreenshots />
    </div>
  );
}

function Spacer() {
  return <div className={"bg-primary h-5"}></div>;
}

function HomeScreen() {
  return (
    <div className="relative z-0 top-[75px] w-full overflow-clip">
      <Welcome />
      <Spacer />
      <About />
      <Spacer />
      <DownloadApp />
      <Spacer />
      <JoinDiscordServer />
      <Spacer />
      <GettingStarted />
      <Spacer />
      <Testimonials />
      <Spacer />
      <FAQ />
      <Spacer />
      <Contact />
      <Footer />
    </div>
  );
}

function JoinDiscordServer() {
  return (
    <div
      id="community"
      className="bp-5 p-0 md:p-10 lg:text-start text-center text-primary flex flex-col justify-evenly content-center bg-gradient-to-r from-background to-surface "
    >
      <div className="flex py-10 text-primary flex-col lg:flex-row lg:justify-evenly items-center content-center">
        <div className="flex flex-col max-w-prose">
          <h2 className="bg-green text-6xl sm:text-7xl lg:text-8xl rounded-2xl pb-10 px-5">
            Join the community
          </h2>
          <p className="text-xl px-5 ">
            We invite you to the PlayGuru Community on Discord, where you can
            connect with other guitarists, ask questions about the app and more!
          </p>
        </div>
        <div className="pl-10 pr-10 pt-10 lg:pt-0 flex-none self-center content-center items-center justify-center ">
          <div className="shadow-2xl bg-gradient-to-b from-orange-500 to-orange-700 rounded-3xl p-10 items-center flex flex-col">
            <h1 className="text-center xl:text-5xl text-3xl font-bold mb-5">
              Discord Server
            </h1>
            <div className="bg-primary rounded-full m-5 p-2 shadow-2xl">
              <img
                alt="screenshot of the list of exercises in PlayGuru"
                src={discord}
                width={200}
                className="p-5 "
              />
            </div>
            <a
              href={"https://discord.gg/uFrc8JEPdj"}
              className="bg-primary text-on_primary hover:bg-on_primary hover:text-primary mt-5 p-3 px-10 md:text-2xl rounded-3xl shadow-2xl"
            >
              Join now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

function DownloadApp() {
  return (
    <div
      id="download"
      className="flex flex-col items-center py-20 bg-primary text-on_primary"
    >
      <h2 className="text-center text-6xl md:text-8xl ">Download now</h2>
      <img
        className="pt-10 m-5 md:scale-150 md:m-16"
        width={200}
        src={logo}
        alt="playguru logo with rounded corners"
      />
      <p className="text-center p-10 text-xl lg:text-2xl">
        As of right now PlayGuru is in public beta and available for free on iOS
        and Android.
        <br />
        Click your store of choice below and try PlayGuru out for yourself.
        <br />
        Don't forget to let us know what you think!
      </p>
      <StoreIcons
        className="mt-5"
        appStoreLink="https://testflight.apple.com/join/hsTwEt7B"
        playStoreLink="https://play.google.com/store/apps/details?id=app.playguru"
      />
    </div>
  );
}

interface StoreIconProps {
  className?: string;
  appStoreLink: string;
  playStoreLink: string;
}

function StoreIcons({
  className,
  appStoreLink,
  playStoreLink,
}: StoreIconProps) {
  const styling = `flex md:flex-row flex-col items-center justify-center m-0 ${className}`;
  return (
    <div className={styling}>
      <a href={appStoreLink}>
        <img
          className="w-72 sm:w-80 mx-5 my-1"
          src={
            "https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
          }
          alt={"AppStore"}
        />
      </a>
      <a href={playStoreLink}>
        <img
          className="w-72 sm:w-80 mx-5 my-1"
          src={
            "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
          }
          alt="Play Store"
        />
      </a>
    </div>
  );
}

/* eslint-enable */
export default HomeScreen;
